import { useEffect, useState } from "react";
import { Badge } from "antd";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { apiLaunchPad } from "../../../api/apiLaunchPad";
import { ProjectEnum } from "../../../type/enum";
import ProjectList from "./ProjectList";

const ProjectComponents = () => {
  const [activeKey, setActiveKey] = useState<ProjectEnum>(ProjectEnum.LIVE);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [listPools, setListPools] = useState<{
    [key in ProjectEnum]: any[];
  }>({
    [ProjectEnum.LIVE]: [],
    [ProjectEnum.UPCOMING]: [],
    [ProjectEnum.ENDED]: [],
  });

  const getListPools = async (tab: ProjectEnum) => {
    setLoading(true);
    try {
      const res = await (tab === ProjectEnum.LIVE
        ? apiLaunchPad.getPoolLive(1, "")
        : tab === ProjectEnum.UPCOMING
          ? apiLaunchPad.getPoolUpcoming(1, "", "")
          : apiLaunchPad.getPoolEnd(1, "", ""));
      if (res.data.code === 200) {
        setListPools((prev) => ({ ...prev, [tab]: res.data.data }));
        if (tab === ProjectEnum.LIVE && res.data.data.length === 0) {
          setActiveKey(ProjectEnum.UPCOMING);
        }
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getListPools(activeKey);
  }, [activeKey]);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
    const fetchAllPools = async () => {
      setLoading(true);
      try {
        await Promise.all([
          getListPools(ProjectEnum.LIVE),
          getListPools(ProjectEnum.UPCOMING),
          getListPools(ProjectEnum.ENDED),
        ]);
      } catch (error) {
        console.log("Error fetching all pools: ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAllPools();
  }, []);

  return (
    <div className="main-page-opening" data-aos="fade-up">
      <div className="container" data-aos="fade-up">
        <div className="wrap-opening" data-aos="fade-up">
          <div className="mark-title" data-aos="fade-up">
            Launchpad projects
          </div>
          <div className="tabs-home-page" data-aos="fade-up">
            <div className="mb-3 flex justify-center items-center gap-3 sm:gap-4">
              {Object.entries(ProjectEnum).map(([label, value]) => (
                <div
                  key={value}
                  className={`cursor-pointer ${
                    activeKey === value ? "bg-customBlue-500" : "bg-white"
                  }`}
                  onClick={() => setActiveKey(value as ProjectEnum)}
                >
                  <Badge
                    count={listPools[value as ProjectEnum].length}
                    overflowCount={99}
                    style={{ backgroundColor: "#0094ff", color: "white" }}
                  >
                    <div
                      className={`py-2 px-3 sm:py-3 sm:px-4 text-base min-[420px]:text-sm sm:text-xl font-Montserrat font-semibold ${
                        activeKey === value
                          ? "text-white"
                          : "text-text-secondary"
                      }`}
                    >
                      {label}
                    </div>
                  </Badge>
                </div>
              ))}
            </div>
            <div>
              <ProjectList
                projectList={
                  listPools[activeKey].length >= 6
                    ? listPools[activeKey].slice(0, 6)
                    : listPools[activeKey]
                }
                loading={loading}
                filter={activeKey}
              />
            </div>
            <div className="group-button">
              <button
                className="main-button res"
                onClick={() => navigate("/launchpads")}
              >
                VIEW ALL
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectComponents;
